import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QbeIcons } from 'qbe-components';

export interface RadioButton {
  label: string;
  qbeIcon?: QbeIcons;
  ndbxIcon?: string;
  value: string;
}

@Component({
  selector: 'app-radio-buttons',
  templateUrl: './radio-buttons.component.html',
  styleUrls: ['./radio-buttons.component.scss'],
})
export class RadioButtonsComponent {
  @Input() name = 'radio';
  @Input() selected: string | null = null;
  @Input() options!: RadioButton[];
  @Input() align: 'left' | 'center' | 'right' = 'center';
  @Output() change: EventEmitter<RadioButton> = new EventEmitter<RadioButton>();
}
